/** @ignore */
export const expectedAtomButGot = "Expected an Atom instances, but got:";
